import React from "react";

const HeroSection = ({ dataHeroSection }) => {

  const cardType=dataHeroSection.type;
  const title=dataHeroSection.title;
  return (
    <div className="w-full flex justify-center">
      <div className="w-full flex flex-col sm:w-full md:w-full lg:w-4/5 xl:w-5/6 px-2 md:px-0">
      {/* Heading  */}
      <div>
        {
          cardType=="Services" &&
          <h2 className=" flex justify-center items-center text-center text-[24px] font-bold">{title}</h2>
        }
      </div>
        {/* Section Description */}
        <div className=" flex content-center xl:h-full h-[200px] md:overflow-y-hidden overflow-y-auto">
          <p className=" text-[16px] text-[#7E7E7E]  leading-[27px] ">
           {dataHeroSection.info}
          </p>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
